import { SCol, SRow } from '@avalara/skylab-sdk/react';

import type { QuestionType } from '../../../../../types/prequal-questionnaire';
import NexusThresholdsQuestion from './nexus-thresholds';
import QuestionSelect from './question-select';

type QuestionnaireProps = {
  pageQuestionData: QuestionType;
  questionSelectedAnswers: Array<string>;
  isFollowUp?: boolean;
};

const Questionnaire = ({ pageQuestionData, questionSelectedAnswers, isFollowUp }: QuestionnaireProps) => {
  const {
    id,
    inputData: {
      inputType,
      inputAnswers: { options, otherOptions },
    },
    optionsHeader,
    otherOptionsHeader,
    questionTitle,
    subText,
  } = pageQuestionData;

  const isNexusThresholdQuestion = id === 'exceedingNexusThresholds' || id === 'approachingNexusThresholds';

  if (isNexusThresholdQuestion) {
    return (
      <NexusThresholdsQuestion questionData={pageQuestionData} questionSelectedAnswers={questionSelectedAnswers} />
    );
  }

  return (
    <SRow className='flex flex-dir-col'>
      <SCol className='text-left pad-bottom-none'>
        {isFollowUp ? (
          <h2 data-ref='buy.prequal.questionnaire.follow-up.header'>{questionTitle}</h2>
        ) : (
          <h1 data-ref='buy.prequal.questionnaire.header'>{questionTitle}</h1>
        )}
        <p className='margin-bottom-sm'>{subText}</p>
      </SCol>

      <SCol>
        {!!optionsHeader && (
          <div data-ref='buy.prequal.questionnaire.options-header' className='text-xs-strong margin-bottom-sm'>
            {optionsHeader}
          </div>
        )}
        <QuestionSelect
          questionId={pageQuestionData.id}
          options={options}
          questionSelectedAnswers={questionSelectedAnswers}
          questionType={inputType}
          groupName={`${pageQuestionData.id}Group`}
        />
      </SCol>

      {!!otherOptions?.length && (
        <>
          {!!otherOptionsHeader && (
            <SCol data-ref='buy.prequal.questionnaire.other-options-header' className='pad-bottom-sm'>
              {otherOptionsHeader}
            </SCol>
          )}

          <SCol>
            <QuestionSelect
              questionId={pageQuestionData.id}
              options={otherOptions}
              questionSelectedAnswers={questionSelectedAnswers}
              questionType={inputType}
              groupName={`${pageQuestionData.id}OtherGroup`}
            />
          </SCol>
        </>
      )}
    </SRow>
  );
};

export default Questionnaire;
